import { FsAdvancedMarker } from '@lib/geo/google/map';
import { t } from '@lib/translation';
import { COLORS, THEME } from '@lib/ui/theme';

import { FsLprCamera } from '../../api/models';

export class FsLprCameraAdvancedMarker extends FsAdvancedMarker {
  constructor(public camera: FsLprCamera, public animate?: boolean) {
    super(
      {
        position: new google.maps.LatLng(
          camera.position.coordinates[1],
          camera.position.coordinates[0],
        ),
        title: camera.id,
        content: document.createElement('div'),
        collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
      },
      '.fs__advanced-marker-expand',
    );
    const content: any = this.getMarker().content;
    const imgIcon = this._getCameraIcon(camera).makeIcon;

    if (this.camera.type?.toString()?.toLowerCase().includes('vigilant')) {
      content.classList.add('fs__lpr-camera-advanced-marker-vigilant');
    }

    if (animate) {
      content.classList.add('fs__lpr-camera-advanced-marker-animate');
    } else {
      content.classList.add('fs__lpr-camera-advanced-marker');
    }
    content.style.border = `2px solid ${camera.up ? THEME.success : COLORS['amber-300']}`;
    content.innerHTML = animate
      ? `
    <img class="fs__lpr-camera-icon" src="/assets/fusus-icons/PNG/${imgIcon}.png"/>
    <div class="fs_lpr_camera-details-marker">
      <dt>${t('common.id')}:</dt>
      <dd class="fs-text-wrap">
        ${camera.id}
      </dd>
      <dt>${t('vehicleIntelligence.lastObservedDate')}:</dt>
      <dd class="fs-text-wrap">
        ${this.formatDate(camera.lastObservedDate).toDateString()}
      </dd>
      <dt>${t('vehicleIntelligence.readsOnLastObserved')}:</dt>
      <dd class="fs-text-wrap">
        ${camera.readsOnLastObserved}
      </dd>
      <dt>${t('common.type')}:</dt>
      <dd class="fs-text-wrap">
        ${camera.type}
      </dd>
    </div>
  `
      : `
      <img class="fs__lpr-camera-icon" src="/assets/fusus-icons/PNG/${imgIcon}.png"/>
    `;
    content.classList.add('fs__center-marker');
  }

  get icon(): string {
    return this._getCameraIcon(this.camera);
  }

  public formatDate(data: Date | string): Date {
    const date = new Date(data);
    date.setHours(date.getHours() + 12);
    return date;
  }

  private _getCameraIcon(item: FsLprCamera): any {
    switch (true) {
      case item.type?.toString()?.toLowerCase() === 'fs alpr':
        return { makeIcon: 'Icon_FS', hasIcon: true };
      case item.type?.toString()?.toLowerCase()?.includes('genetec'):
        return { makeIcon: 'Icon_Genetec', hasIcon: true };
      case item.type?.toString()?.toLowerCase()?.includes('vigilant'):
        return { makeIcon: 'Icon_Vigilant', hasIcon: true };
      case item.type?.toString()?.toLowerCase()?.includes('rekor'):
        return { makeIcon: 'Icon_Rekor', hasIcon: true };
      case item.type?.toString()?.toLowerCase()?.includes('dronesense'):
        return { makeIcon: 'Icon_DroneSense', hasIcon: true };
      case item.type?.toString()?.toLowerCase()?.includes('epic'):
        return { makeIcon: 'EPIC-IO', hasIcon: true };
      case item.type?.toString()?.toLowerCase() === 'rt alpr':
        return { makeIcon: 'Icon_LPAR', hasIcon: true };
      default:
        return { makeIcon: 'FususALPR', hasIcon: false };
    }
  }
}
